import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { TotalOcurrences } from './TotalOcurrences';
import { HomeAndTerritorialVisits } from './HomeAndTerritorialVisits';
import { AnualOcurrencesEvolution } from './AnualOcurrencesEvolution';
import { OcurrenceByForwarding } from './OcurrenceByForwarding';
import { OcurrencesByCallLocation } from './OcurrencesByCallLocation';

const Ocurrences = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards align-items-stretch">
                <TotalOcurrences />
                <HomeAndTerritorialVisits />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <AnualOcurrencesEvolution />
                <OcurrenceByForwarding />
            </div>
            <OcurrencesByCallLocation />
        </>
    );
};

export default Ocurrences;
